import { DetailedChain } from "../chains";
import { GasData } from "../gas";
import { DefiTransaction } from "./defi";

export type TokenPriceDto = {
  token: string;
  average: string;
  exchanges: object;
};

export type TokenPriceResponseDto = TokenPriceDto[];

export type TokenPrices = {
  [key: string]: number;
};

export type DefiTransactionDto = DefiTransaction[];

export type GasPriceResponseDto = GasData[];

export type DetailedChainsResponseDto = DetailedChain[];

export type AccountBalanceResponseDto = {
  balances: AccountBalance[];
  message: string;
};

// Account Balance
export type AccountBalance = {
  protocolSymbol: string | null;
  protocolName: string;
  positionType: string;
  quantity: number;
  value: number; // value in USD
  price: number; // price per token in USD
  changes: {
    absolute_1d: number;
    percent_1d: number;
  };
  token: Currency;
  updatedAt: string;
  chainId: string;
};

export type PricesResponseDto = string[];

export type Currency = {
  name: string;
  icon: string;
  symbol: string;
};

export type RatesResponseDto = {
  base: string;
  rates: Record<string, number>;
};
